<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Dispositivos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(style="border-radius:5px;background-color:white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height:auto;width:140px;')
        v-card(style="border-radius:5px;background-color:black;")
          v-card-title(style="padding:7px;").justify-center
            span.white--text Administración de Dispositivos

    //- Estadísticas resumen
    v-layout(row wrap style="margin:12px 4px 0;")
      v-flex(xs12 sm4 style="padding:4px;")
        v-card(style="border-radius:14px;background:linear-gradient(135deg,#ff6500,#e42e28);box-shadow:0 4px 20px rgba(228,46,40,0.4);")
          v-card-text(style="padding:18px 16px;")
            v-layout(row align-center)
              v-icon(style="font-size:40px;color:rgba(255,255,255,0.85);margin-right:14px;") devices
              div
                div(style="font-size:32px;font-weight:800;color:white;line-height:1;") {{ totalDispositivos }}
                div(style="font-size:11px;color:rgba(255,255,255,0.8);letter-spacing:1.5px;margin-top:2px;") TOTAL DISPOSITIVOS
      v-flex(xs12 sm4 style="padding:4px;")
        v-card(style="border-radius:14px;background:linear-gradient(135deg,#00897b,#00695c);box-shadow:0 4px 20px rgba(0,137,123,0.4);")
          v-card-text(style="padding:18px 16px;")
            v-layout(row align-center)
              v-icon(style="font-size:40px;color:rgba(255,255,255,0.85);margin-right:14px;") check_circle
              div
                div(style="font-size:32px;font-weight:800;color:white;line-height:1;") {{ dispositivosActivos }}
                div(style="font-size:11px;color:rgba(255,255,255,0.8);letter-spacing:1.5px;margin-top:2px;") ACTIVOS
      v-flex(xs12 sm4 style="padding:4px;")
        v-card(style="border-radius:14px;background:linear-gradient(135deg,#37474f,#263238);box-shadow:0 4px 20px rgba(0,0,0,0.35);")
          v-card-text(style="padding:18px 16px;")
            v-layout(row align-center)
              v-icon(style="font-size:40px;color:rgba(255,255,255,0.85);margin-right:14px;") lock
              div
                div(style="font-size:32px;font-weight:800;color:white;line-height:1;") {{ dispositivosBloqueados }}
                div(style="font-size:11px;color:rgba(255,255,255,0.8);letter-spacing:1.5px;margin-top:2px;") BLOQUEADOS

    //- Config dispositivos
    v-layout(row wrap style="margin:10px 4px 0;")
      v-flex(xs12 sm6 style="padding:4px;")
        v-card(style="border-radius:14px;border-left:4px solid #e42e28;height:100%;")
          v-card-text(style="padding:12px 16px;")
            v-layout(row align-center)
              v-icon(style="color:#e42e28;margin-right:10px;") settings_suggest
              div(style="flex:1;")
                div(style="font-weight:700;font-size:14px;color:#212121;") Registro de nuevos dispositivos
                div(style="font-size:12px;color:#9e9e9e;margin-top:1px;")
                  | {{ config.dispositivo_activo_por_defecto ? 'Los nuevos dispositivos se registran como Activos — ingresan de inmediato.' : 'Los nuevos dispositivos se registran como Bloqueados — requieren activación manual.' }}
              v-switch(
                v-model="config.dispositivo_activo_por_defecto"
                :color="config.dispositivo_activo_por_defecto ? '#00897b' : '#e42e28'"
                hide-details
                style="margin:0;flex-shrink:0;"
                @change="guardarConfig"
              )
              v-chip(
                small
                :color="config.dispositivo_activo_por_defecto ? '#e8f5e9' : '#ffebee'"
                :text-color="config.dispositivo_activo_por_defecto ? '#2e7d32' : '#c62828'"
                style="margin-left:10px;font-weight:700;"
              ) {{ config.dispositivo_activo_por_defecto ? 'Activo' : 'Bloqueado' }}
      v-flex(xs12 sm4 style="padding:4px;")
        v-card(style="border-radius:14px;border-left:4px solid #ff6500;height:100%;")
          v-card-text(style="padding:12px 16px;")
            v-layout(row align-center)
              v-icon(style="color:#ff6500;margin-right:10px;") system_update
              div(style="flex:1;")
                div(style="font-weight:700;font-size:14px;color:#212121;") Versión mínima requerida
                div(style="font-size:12px;color:#9e9e9e;margin-top:1px;") Fuerza actualización si la app es menor a esta.
              v-text-field(
                v-model="config.version_minima"
                hide-details
                outline
                dense
                style="max-width:100px;margin:0 8px;"
                placeholder="1.0.0"
              )
              v-btn(icon small style="background:#f5f5f5;margin:0;" @click="guardarConfig")
                v-icon(color="#e42e28") save
      v-flex(xs12 sm4 style="padding:4px;")
        v-card(style="border-radius:14px;border-left:4px solid #00897b;height:100%;")
          v-card-text(style="padding:12px 16px;")
            v-layout(row align-center)
              v-icon(style="color:#00897b;margin-right:10px;") new_releases
              div(style="flex:1;")
                div(style="font-weight:700;font-size:14px;color:#212121;") Versión más reciente
                div(style="font-size:12px;color:#9e9e9e;margin-top:1px;") Se muestra como banner en el dashboard de la app.
              v-text-field(
                v-model="config.version_ultima"
                hide-details
                outline
                dense
                style="max-width:100px;margin:0 8px;"
                placeholder="1.0.0"
              )
              v-btn(icon small style="background:#f5f5f5;margin:0;" @click="guardarConfig")
                v-icon(color="#00897b") save

    //- Filtros y búsqueda
    v-layout(row wrap style="margin:12px 4px 0;" align-center)
      v-flex(xs12 sm5 style="padding:4px;")
        v-text-field(
          v-model="busqueda"
          prepend-inner-icon="search"
          label="Buscar vendedor..."
          outline
          clearable
          hide-details
          style="border-radius:8px;"
        )
      v-flex(xs12 sm4 style="padding:4px;")
        v-btn-toggle(v-model="tipoUsuario" mandatory)
          v-btn(value="vendedor" small)
            v-icon(small style="margin-right:4px;") person
            | Vendedores
          v-btn(value="supervisor" small)
            v-icon(small style="margin-right:4px;") supervisor_account
            | Supervisores
      v-flex(xs12 sm3 style="padding:4px;")
        v-select(
          v-model="filtroEstado"
          :items="[{text:'Todos',value:'todos'},{text:'Activos',value:'activo'},{text:'Bloqueados',value:'bloqueado'}]"
          label="Estado"
          outline
          hide-details
        )

    //- Loader
    v-layout(v-if="loading" justify-center style="margin-top:50px;")
      v-progress-circular(indeterminate color="#e42e28" size="52" width="4")

    //- Sin resultados
    div(v-else-if="resultadosFiltrados.length === 0" style="text-align:center;padding:60px 20px;")
      v-icon(style="font-size:72px;color:#e0e0e0;") phonelink_off
      p(style="margin-top:12px;font-size:16px;color:#bdbdbd;") No hay dispositivos registrados.

    //- Cards por vendedor
    div(v-else style="margin:10px 4px 0;")
      v-card(
        v-for="(item, index) in resultadosFiltrados"
        :key="index"
        style="border-radius:14px;margin-bottom:10px;overflow:hidden;box-shadow:0 2px 12px rgba(0,0,0,0.1);"
      )
        //- Header del vendedor
        v-card-title(
          :style="'background:linear-gradient(135deg,' + (expanded[index] ? '#e42e28,#ff6500' : '#2c2c2c,#3a3a3a') + ');padding:14px 16px;cursor:pointer;transition:background 0.3s;'"
          @click="toggleExpand(index)"
        )
          v-layout(row align-center)
            v-avatar(size="42" :style="'background:' + (expanded[index] ? 'rgba(255,255,255,0.25)' : '#e42e28') + ';margin-right:14px;flex-shrink:0;border:2px solid rgba(255,255,255,0.2);'")
              span(style="color:white;font-weight:800;font-size:17px;") {{ (item.ven_des || item.co_ven || '?')[0].toUpperCase() }}
            div(style="flex:1;min-width:0;")
              div(style="color:white;font-weight:700;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;") {{ item.ven_des || '—' }}
              div(style="color:rgba(255,255,255,0.65);font-size:12px;margin-top:1px;")
                | Código: {{ item.co_ven }}
                span(style="margin-left:10px;")
                  v-icon(x-small style="color:rgba(255,255,255,0.5);vertical-align:middle;") phone_android
                  span(style="margin-left:2px;") v{{ item.version_app || '—' }}
            v-chip(
              small
              :color="totalActivosPorVendedor(item) > 0 ? '#00897b' : 'rgba(255,255,255,0.1)'"
              text-color="white"
              style="margin-right:6px;font-weight:600;"
            )
              v-icon(left small) check_circle
              | {{ totalActivosPorVendedor(item) }}
            v-chip(
              small
              :color="totalBloqueadosPorVendedor(item) > 0 ? '#37474f' : 'rgba(255,255,255,0.1)'"
              text-color="white"
              style="margin-right:10px;font-weight:600;"
            )
              v-icon(left small) lock
              | {{ totalBloqueadosPorVendedor(item) }}
            v-icon(style="color:rgba(255,255,255,0.8);") {{ expanded[index] ? 'expand_less' : 'expand_more' }}

        //- Dispositivos expandibles
        v-slide-y-transition
          div(v-show="expanded[index]" style="background:#fafafa;")
            div(
              v-for="(disp, di) in (item.dispositivos || [])"
              :key="di"
              :style="'border-left:4px solid ' + (disp.activo ? '#00897b' : '#e42e28') + ';border-bottom:1px solid #f0f0f0;transition:border-color 0.2s;'"
            )
              v-layout(row wrap align-center style="padding:12px 16px;")
                //- Icono plataforma
                v-flex(xs1 style="min-width:52px;")
                  v-avatar(
                    size="38"
                    :style="'background:' + (disp.platform === 'android' ? '#e8f5e9' : disp.platform === 'ios' ? '#e3f2fd' : '#f3e5f5') + ';'"
                  )
                    v-icon(
                      size="22"
                      :color="disp.platform === 'android' ? '#2e7d32' : disp.platform === 'ios' ? '#1565c0' : '#6a1b9a'"
                    ) {{ disp.platform === 'android' ? 'android' : disp.platform === 'ios' ? 'phone_iphone' : 'devices_other' }}
                //- Device ID + Alias
                v-flex(xs12 sm5 style="padding:0 12px;")
                  div(style="font-size:10px;color:#bdbdbd;text-transform:uppercase;letter-spacing:1px;font-weight:600;") Device ID
                  div(style="font-family:monospace;font-size:12px;color:#424242;word-break:break-all;margin-top:2px;") {{ disp.device_id }}
                  v-layout(row align-center style="margin-top:6px;")
                    v-text-field(
                      v-model="disp.aliasEdit"
                      :placeholder="disp.alias || 'Agregar alias...'"
                      hide-details
                      solo
                      flat
                      dense
                      style="font-size:12px;background:#f5f5f5;border-radius:6px;max-width:180px;"
                      @keyup.enter="guardarAlias(item, disp)"
                    )
                    v-btn(
                      icon small
                      style="background:#e3f2fd;margin-left:4px;width:28px;height:28px;"
                      @click="guardarAlias(item, disp)"
                    )
                      v-icon(size="16" color="#1565c0") check
                //- Plataforma
                v-flex(xs6 sm2 style="padding:0 8px;")
                  div(style="font-size:10px;color:#bdbdbd;text-transform:uppercase;letter-spacing:1px;font-weight:600;") Plataforma
                  div(style="font-size:13px;font-weight:600;text-transform:capitalize;margin-top:2px;color:#424242;") {{ disp.platform || '—' }}
                //- Modelo
                v-flex(xs6 sm2 style="padding:0 8px;")
                  div(style="font-size:10px;color:#bdbdbd;text-transform:uppercase;letter-spacing:1px;font-weight:600;") Modelo
                  div(style="font-size:12px;font-weight:600;margin-top:2px;color:#424242;") {{ disp.modelo || '—' }}
                  div(v-if="disp.ram || disp.almacenamiento" style="font-size:11px;color:#9e9e9e;margin-top:2px;")
                    span(v-if="disp.ram") RAM: {{ disp.ram }}
                    span(v-if="disp.ram && disp.almacenamiento")  •  
                    span(v-if="disp.almacenamiento") {{ disp.almacenamiento }}
                //- Fecha
                v-flex(xs6 sm2 style="padding:0 8px;")
                  div(style="font-size:10px;color:#bdbdbd;text-transform:uppercase;letter-spacing:1px;font-weight:600;") Registro
                  div(style="font-size:12px;margin-top:2px;color:#616161;") {{ formatFecha(disp.fecha_registro) }}
                //- Estado
                v-flex(xs6 sm1 style="padding:0 8px;")
                  v-chip(
                    small
                    :color="disp.activo ? '#e8f5e9' : '#ffebee'"
                    :text-color="disp.activo ? '#2e7d32' : '#c62828'"
                    style="font-weight:700;border:1px solid;font-size:11px;"
                    :style="'border-color:' + (disp.activo ? '#a5d6a7' : '#ef9a9a')"
                  )
                    v-icon(left small :color="disp.activo ? '#2e7d32' : '#c62828'") {{ disp.activo ? 'check_circle' : 'block' }}
                    | {{ disp.activo ? 'Activo' : 'Bloqueado' }}
                //- Acciones
                v-flex(xs6 sm1 style="text-align:right;white-space:nowrap;")
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-btn(
                        icon small v-on="on"
                        @click="toggleDispositivo(item, disp)"
                        :style="'background:' + (disp.activo ? '#fff3e0' : '#e8f5e9') + ';margin:0 2px;width:32px;height:32px;'"
                      )
                        v-icon(size="18" :color="disp.activo ? '#e65100' : '#2e7d32'") {{ disp.activo ? 'lock' : 'lock_open' }}
                    span {{ disp.activo ? 'Bloquear' : 'Activar' }}
                  v-tooltip(bottom)
                    template(v-slot:activator='{ on }')
                      v-btn(
                        icon small v-on="on"
                        @click="confirmarEliminar(item, disp)"
                        style="background:#ffebee;margin:0 2px;width:32px;height:32px;"
                      )
                        v-icon(size="18" color="#c62828") delete_outline
                    span Eliminar

    //- Dialog eliminar
    v-dialog(v-model='dialogEliminar' persistent max-width='420px')
      v-card(style="border-radius:16px;overflow:hidden;")
        div(style="background:linear-gradient(135deg,#e42e28,#ff6500);padding:24px 20px;text-align:center;")
          v-avatar(size="64" style="background:rgba(255,255,255,0.2);margin-bottom:12px;")
            v-icon(style="font-size:36px;color:white;") delete_forever
          div(style="color:white;font-size:18px;font-weight:700;") Eliminar dispositivo
        v-card-text(style="padding:24px 20px;text-align:center;")
          p(style="color:#616161;margin-bottom:14px;font-size:14px;") ¿Seguro que deseas eliminar este dispositivo?
          div(style="background:#f5f5f5;border-radius:10px;padding:12px;font-family:monospace;font-size:11px;color:#757575;word-break:break-all;border-left:3px solid #e42e28;")
            | {{ dispositivoAEliminar ? dispositivoAEliminar.device_id : '' }}
        v-card-actions(style="padding:0 20px 20px;justify-content:center;gap:12px;")
          v-btn(style="background:linear-gradient(135deg,#e42e28,#ff6500);color:white;border-radius:10px;min-width:130px;font-weight:600;" @click.native='eliminarDispositivo')
            v-icon(left small) delete
            | Eliminar
          v-btn(style="background:#f5f5f5;color:#424242;border-radius:10px;min-width:130px;font-weight:600;" @click.native='dialogEliminar = false')
            | Cancelar
</template>

<script>
import Api from "@/services/methods";
export default {
  name: "Dispositivos",
  data: () => ({
    loading: false,
    tipoUsuario: "vendedor",
    resultados: [],
    expanded: {},
    busqueda: "",
    filtroEstado: "todos",
    dialogEliminar: false,
    dispositivoAEliminar: null,
    vendedorDeDispositivo: null,
    aliasGuardando: false,
    config: {
      _id: null,
      dispositivo_activo_por_defecto: true,
      version_minima: '1.0.0',
      version_ultima: '1.0.0'
    }
  }),
  computed: {
    resultadosFiltrados() {
      return this.resultados.filter(item => {
        const nombre = (item.ven_des || item.co_ven || "").toLowerCase();
        const matchBusqueda = !this.busqueda || nombre.includes(this.busqueda.toLowerCase());
        if (!matchBusqueda) return false;
        if (this.filtroEstado === "todos") return true;
        const disps = item.dispositivos || [];
        if (this.filtroEstado === "activo") return disps.some(d => d.activo);
        if (this.filtroEstado === "bloqueado") return disps.some(d => !d.activo);
        return true;
      });
    },
    totalDispositivos() {
      return this.resultados.reduce((acc, v) => acc + (v.dispositivos ? v.dispositivos.length : 0), 0);
    },
    dispositivosActivos() {
      return this.resultados.reduce((acc, v) => acc + (v.dispositivos ? v.dispositivos.filter(d => d.activo).length : 0), 0);
    },
    dispositivosBloqueados() {
      return this.resultados.reduce((acc, v) => acc + (v.dispositivos ? v.dispositivos.filter(d => !d.activo).length : 0), 0);
    }
  },
  watch: {
    tipoUsuario() {
      this.expanded = {};
      this.initialize();
    }
  },
  created() {
    this.initialize();
    this.loadConfig();
  },
  methods: {
    loadConfig() {
      Api.get("settings")
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.config = res.data[0];
            if (this.config.dispositivo_activo_por_defecto === undefined) {
              this.config.dispositivo_activo_por_defecto = true;
            }
            if (!this.config.version_minima) {
              this.config.version_minima = '1.0.0';
            }
            if (!this.config.version_ultima) {
              this.config.version_ultima = '1.0.0';
            }
          }
        })
        .catch(err => console.log(err));
    },
    guardarConfig() {
      const payload = { ...this.config, dispositivo_activo_por_defecto: this.config.dispositivo_activo_por_defecto };
      const req = this.config._id ? Api.put("settings", payload) : Api.post("settings", payload);
      req
        .then(() => {
          this.$swal.fire(
            "Configuración guardada",
            `Nuevos dispositivos se registrarán como ${this.config.dispositivo_activo_por_defecto ? 'Activos' : 'Bloqueados'} por defecto.`,
            "success"
          );
        })
        .catch(err => {
          console.log(err);
          this.$swal.fire("Oops...", "Error al guardar la configuración.", "error");
        });
    },
    initialize() {
      this.loading = true;
      const endpoint = this.tipoUsuario === "vendedor"
        ? "vendedor/dispositivos"
        : "usuario/dispositivos";
      Api.get(endpoint)
        .then(res => {
          this.resultados = res.data.map(item => ({
            ...item,
            dispositivos: (item.dispositivos || []).map(d => ({ ...d, aliasEdit: d.alias || '' }))
          }));
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$swal.fire("Oops...", "Error al cargar los dispositivos.", "error");
        });
    },
    guardarAlias(vendedor, dispositivo) {
      const alias = (dispositivo.aliasEdit || '').trim();
      Api.put("dispositivoAlias", { device_id: dispositivo.device_id, alias })
        .then(() => {
          dispositivo.alias = alias;
          this.$swal.fire(
            "Alias guardado",
            `El alias "${alias || '(sin alias)'}" fue asignado correctamente.`,
            "success"
          );
        })
        .catch(err => {
          console.log(err);
          this.$swal.fire("Oops...", "Error al guardar el alias.", "error");
        });
    },
    toggleExpand(index) {
      this.$set(this.expanded, index, !this.expanded[index]);
    },
    totalActivosPorVendedor(item) {
      return (item.dispositivos || []).filter(d => d.activo).length;
    },
    totalBloqueadosPorVendedor(item) {
      return (item.dispositivos || []).filter(d => !d.activo).length;
    },
    formatFecha(fecha) {
      if (!fecha) return "-";
      return new Date(fecha).toLocaleDateString("es-VE", {
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit"
      });
    },
    toggleDispositivo(vendedor, dispositivo) {
      const info = {
        co_ven: vendedor.co_ven,
        device_id: dispositivo.device_id,
        activo: !dispositivo.activo
      };
      const endpoint = this.tipoUsuario === "vendedor"
        ? "vendedor/dispositivo"
        : "usuario/dispositivo";
      Api.put(endpoint, info)
        .then(() => {
          this.$swal.fire(
            "Felicidades.!",
            `Dispositivo ${info.activo ? "activado" : "bloqueado"} exitosamente.`,
            "success"
          );
          this.initialize();
        })
        .catch(err => {
          console.log(err);
          this.$swal.fire("Oops...", "Error al actualizar el dispositivo.", "error");
        });
    },
    confirmarEliminar(vendedor, dispositivo) {
      this.vendedorDeDispositivo = vendedor;
      this.dispositivoAEliminar = dispositivo;
      this.dialogEliminar = true;
    },
    eliminarDispositivo() {
      const info = {
        co_ven: this.vendedorDeDispositivo.co_ven,
        device_id: this.dispositivoAEliminar.device_id
      };
      const endpoint = this.tipoUsuario === "vendedor"
        ? "vendedor/dispositivo"
        : "usuario/dispositivo";
      Api.deleteWithBody(endpoint, info)
        .then(() => {
          this.dialogEliminar = false;
          this.dispositivoAEliminar = null;
          this.vendedorDeDispositivo = null;
          this.$swal.fire("Felicidades.!", "Dispositivo eliminado exitosamente.", "success");
          this.initialize();
        })
        .catch(err => {
          console.log(err);
          this.dialogEliminar = false;
          this.$swal.fire("Oops...", "Error al eliminar el dispositivo.", "error");
        });
    }
  }
};
</script>
